export default __webpack_public_path__ + "static/media/15.ec16f707.PNG";